import { computed, unref } from 'vue'
import { useBaseStoreWithOut } from '@/store-pinia/modules/base'
import { useUserStoreWithOut } from '@/store-pinia/modules/user'
import { type PhysicalWarehouseListItem, changePhysicalWarehouseApi } from '@/api/common'
import { useLocale } from './useLocale'
import { getAllPhysicalWarehouseList, getAllRegionWarehouseList } from '@/utils/auth'

/**
 * 物理仓切换hook
 */
export function usePhysicalWarehouse() {
  const baseStore = useBaseStoreWithOut()
  const userStore = useUserStoreWithOut()
  const getPhysicalWarehouseInfo = computed(() => baseStore.getPhysicalWarehouseInfo)
  const getPhysicalWarehouseList = computed(() => userStore.getUserInfo?.physicsWarehouseList || [])

  const changePhysicalWarehouse = async (physicalWarehouse: PhysicalWarehouseListItem) => {
    const warehouseCode = physicalWarehouse.physicsWarehouseCode
    if (warehouseCode === unref(getPhysicalWarehouseInfo)?.physicsWarehouseCode) {
      return
    }
    try {
      await changePhysicalWarehouseApi({ warehouseCode })
      baseStore.setPhysicalWarehouseInfo(physicalWarehouse)
    } catch (err) {
      console.log('Change physicalwarehoue error: ', err)
    }
  }

  return {
    getPhysicalWarehouseInfo,
    getPhysicalWarehouseList,
    changePhysicalWarehouse,
  }
}

export function getPhysicalWarehouseLabelName(
  physicsWarehouseCode: any,
  physicsWarehouseName?: any,
) {
  try {
    // console.log('physicsWarehouseCode', physicsWarehouseCode)
    const { locale } = useLocale()

    const allPhysicalWarehouses = getAllPhysicalWarehouseList()
    console.log('allPhysicalWarehouses', allPhysicalWarehouses)

    if (Array.isArray(allPhysicalWarehouses) && allPhysicalWarehouses.length) {
      const info = allPhysicalWarehouses.find(
        (item) => item.physicsWarehouseCode === physicsWarehouseCode,
      )
      if (info) {
        return `${physicsWarehouseCode} [${
          locale.value === 'zh_CN' ? info.physicsWarehouseNameCn : info.physicsWarehouseNameEn
        }]`
      } else {
        return physicsWarehouseName
          ? `${physicsWarehouseCode || '--'} [${physicsWarehouseName}]`
          : physicsWarehouseCode || '--'
      }
    } else {
      return physicsWarehouseName
        ? `${physicsWarehouseCode || '--'} [${physicsWarehouseName}]`
        : physicsWarehouseCode || '--'
    }
  } catch (error) {
    console.log(error)
  }
}

export function getRegionWarehouseLabelName(regionWarehouseCode: any, regionWarehouseName?: any) {
  try {
    const { locale } = useLocale()

    const allRegionWarehouses = getAllRegionWarehouseList()

    if (Array.isArray(allRegionWarehouses) && allRegionWarehouses.length) {
      const info = allRegionWarehouses.find(
        (item) => item.regionWarehouseCode === regionWarehouseCode,
      )
      if (info) {
        return `${regionWarehouseCode} [${
          locale.value === 'zh_CN' ? info.regionWarehouseNameCn : info.regionWarehouseNameEn
        }]`
      } else {
        return regionWarehouseName
          ? `${regionWarehouseCode || '--'} [${regionWarehouseName}]`
          : regionWarehouseCode || '--'
      }
    } else {
      return regionWarehouseName
        ? `${regionWarehouseCode || '--'} [${regionWarehouseName}]`
        : regionWarehouseCode || '--'
    }
  } catch (error) {
    console.log(error)
  }
}
